export default "__VITE_ASSET__B622KIIc__"